import React, { useState, useContext } from 'react'
import PropTypes from 'prop-types'
import ReactImgix from 'react-imgix'
import classNames from 'classnames'

import { recipe } from '../../constants'
import { useStyles } from './content-grid-item.styles'
import { UseItemAnimationContext } from '../../hooks/use-item-animation'
import MyListButton from '../../../../components/shared/my-list/my-list-button'
import TileBadge from '../../../../components/shared/badge'

/*
** ContentGridItem displays genre badge for each content item,
** and shows a tick icon when the item is selected.
*/
const ContentGridItem = ({
  imageUri,
  onSelected,
  isSelected,
  contentItemId,
  contentItem
}) => {
  const [isItemHovered, setIsItemHovered] = useState(false)
  const [{ fadeOut }] = useContext(UseItemAnimationContext)
  const canHover = window.matchMedia('(hover: hover)').matches

  const styles = useStyles()

  const { width } = recipe
  const height = width * recipe.ratio
  const cropToRatio = {
    ar: `1:${recipe.ratio}`,
    fit: 'crop'
  }
  const genre = contentItem?.genres?.[0]

  return (
    <div
      className={classNames(styles.container, {
        [styles.fadeOut]: fadeOut && !isSelected
      })}
      onMouseEnter={() => {
        !isSelected && setIsItemHovered(true)
      }}
      onMouseLeave={() => {
        !isSelected && setIsItemHovered(false)
      }}
      onClick={() => {
        onSelected(contentItemId)
      }}
    >
      {/* Apply the dark badge style by defaut, On desktop, switch to green when selected or on hover.
        On mobile and tablet, hover is disabled so only selection changes the color. */}
      {genre && (
        <TileBadge
          title={genre}
          darkBackground={canHover ? (!isSelected && !isItemHovered) : !isSelected}
        />
      )}

      {isSelected && (
        <div className={styles.selectedOverlay}>
          <MyListButton
            contentItem={contentItem}
            isOnMyList
            className={styles.selectedButton}
            isRental={false}
            alt="onboarding recommendation"
            inOnboardingRecommendation
          />
        </div>
      )}

      <div className={classNames(styles.hoverOverlay, {
        [styles.hoverOverlayVisible]: isItemHovered && canHover
      })}
      />

      <ReactImgix
        src={imageUri}
        width={width}
        height={height}
        className={styles.imgix}
        imgixParams={cropToRatio}
      />
    </div>
  )
}

ContentGridItem.propTypes = {
  imageUri: PropTypes.string.isRequired,
  onSelected: PropTypes.func.isRequired,
  isSelected: PropTypes.bool.isRequired,
  contentItemId: PropTypes.string.isRequired,
  contentItem: PropTypes.shape({
    genres: PropTypes.arrayOf(PropTypes.string),
    path: PropTypes.string
  }).isRequired
}

export default ContentGridItem
